import React, { Component } from "react";
import { STATUS } from "../../../../constant";
import TableLoaderTemplate from "../../../../component/TableLoaderTemplate";
import { IssuePendingLoader } from "../../../../component/LoadersTemplate";
// import { isValidArray } from "../../../../helper";
import NoDataFound from "../../../../component/NoDataFound";
import { LoaderPage } from "../../../../component/Loader";
import { get, isEmpty } from "lodash";

class MeetingTable extends Component {
  render() {
    const {
      meetingTableData: { groupedData, groupMonths } = {},
      meetingTableStatus
    } = this.props;
    const templateMeetingStatus =
      !isEmpty(groupedData) &&
      Object.keys(groupedData).map((meetings, idx) => {
        return (
          <tbody>
            <tr key={`key-${idx}`}>
              <td rowSpan={3}>{meetings}</td>
              {groupedData[meetings].map(item => (
                <td>
                  <span>Scheduled</span>
                  <span>{get(item, "scheduled", "")}</span>
                </td>
              ))}
            </tr>

            <tr>
              {groupedData[meetings].map(item => (
                <td>
                  <span>Conducted</span>
                  <span className="state-color-green">
                    {get(item, "conducted", "")}
                  </span>
                </td>
              ))}
            </tr>

            <tr>
              {groupedData[meetings].map(item => (
                <td>
                  <span>Defaulted</span>
                  <span className="state-color-red">
                    {get(item, "defaulted", "")}
                  </span>
                </td>
              ))}
            </tr>
          </tbody>
        );
      });

    return (
      <>
        <table cellPadding={0} cellSpacing={0}>
          {
            <thead>
              {!isEmpty(groupMonths) ? (
                <tr>
                  <th>Meeting by</th>
                  {!isEmpty(groupMonths) &&
                    Object.keys(groupMonths).map((months, idx) => (
                      <th key={`key-${idx}`}>{months}</th>
                    ))}
                </tr>
              ) : null}
            </thead>
          }
          {(meetingTableStatus && (
            <TableLoaderTemplate
              height={60}
              children={<IssuePendingLoader />}
            />
          )) ||
            (!!templateMeetingStatus
              ? templateMeetingStatus
              : (
                  <tr align="center">
                    <td>
                      <NoDataFound />
                    </td>
                  </tr>
                ) || null)}
        </table>
      </>
    );
  }
}

export default MeetingTable;
